<template>
  <div class="config row">
    <b-modal
      ref="formHoliday"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetHolidayPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitHoliday"
      size="sm"
    >
      <h6>{{ holidayTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitHoliday">
        <b-form-text id="holidayNameInputLiveHelp">
          <label for="holidayNameInput">Nome *</label>
        </b-form-text>
        <b-form-input
          v-model="holidayForm.NAME"
          placeholder="Nome *"
          aria-describedby="holidayNameInputLiveHelp holidayNameInputLiveFeedback"
          :state="holidayNameState"
          maxlength="60"
          id="holidayNameInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!holidayNameState"
          id="holidayNameInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-checkbox size="sm" v-model="holidayForm.RECURRING" switch class="mt-2">
          Repete todo ano
        </b-form-checkbox>
        <b-form-text class="mt-2" id="holidayDateInputLiveHelp">
          <label for="holidayDateInput">Data *</label>
        </b-form-text>
        <b-form-input
          v-model="holidayForm.DATE"
          type="date"
          aria-describedby="holidayDateInputLiveHelp holidayDateInputLiveFeedback"
          :state="holidayDateState"
          id="holidayDateInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!holidayDateState"
          id="holidayDateInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <p v-if="holidayForm.RECURRING" class="text-muted small mt-1">
          O ano digitado é ignorado -- repete todo dia {{ holidayDayMonthPreview }}.
        </p>
        <p v-else class="text-muted small mt-1">
          Feriado móvel: precisa ser recadastrado a cada ano.
        </p>
        <p />
      </b-form>
    </b-modal>
    <b-modal
      ref="deleteHoliday"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmDeleteHoliday"
      cancel-title="Cancelar"
      @cancel="resetHolidayPage"
    >
      <h4>{{ holidayTitleDialog }}</h4>
    </b-modal>

    <div class='col-xs-12 mt-sm-1'>
      <div :class="computedClassHeader">
        Configuração / Ajustes
      </div>
      <b-card-group deck :class="computedClass">
        <b-card align="center">
          <div slot='header'>
            <h4>{{!generalForm ? 'Gerais' : 'Editar configurações gerais'}}</h4>
          </div>
          <div class='card-text start-xs'>
            <div v-if='!generalForm'>
              <p><strong>TEMPO AUTONOMIA DA BATERIA:</strong> {{generalSettings.SHUTDOWN_TIMER}} min</p>
              <p><strong>TEMPO MÁXIMO EM MODO MANUAL:</strong> {{generalSettings.MANUAL_TIMER}} min</p>
              <p><strong>PACOTES ENVIADOS NO PING:</strong> {{generalSettings.PING_PACKAGES}} pacotes</p>
            </div>
            <div v-else>
              <b-form novalidate @keyup.enter='submitGeralConfig'>
                <b-form-text id='batInputLiveHelp'>
                  Autonomia da bateria *
                </b-form-text>
                <b-form-input v-model='editGeneralSett.SHUTDOWN_TIMER'
                              placeholder='Canal'
                              aria-describedby='batInputLiveHelp batInputLiveFeedback'
                              type='number'
                              :state='batState'
                              :min='0'>
                </b-form-input>
                <b-form-invalid-feedback v-if='!batState' id='batInputLiveFeedback'>
                  Campo inválido.
                </b-form-invalid-feedback>
                <b-form-text id='manualInputLiveHelp'>
                  Tempo máximo em manual *
                </b-form-text>
                <b-form-input v-model='editGeneralSett.MANUAL_TIMER'
                              placeholder='Time out'
                              aria-describedby='manualInputLiveHelp manualInputLiveFeedback'
                              type='number'
                              :state='manualState'
                              :min='0'>
                </b-form-input>
                <b-form-invalid-feedback v-if='!manualState' id='manualInputLiveFeedback'>
                  Campo inválido.
                </b-form-invalid-feedback>
                <b-form-text id='packInputLiveHelp'>
                  Número de pacotes enviados no ping *
                </b-form-text>
                <b-form-input v-model='editGeneralSett.PING_PACKAGES'
                              placeholder='Tentativas'
                              aria-describedby='packInputLiveHelp packInputLiveFeedback'
                              type='number'
                              :state='packState'
                              :min='0'>
                </b-form-input>
                <b-form-invalid-feedback v-if='!packState' id='packInputLiveFeedback'>
                  Campo inválido.
                </b-form-invalid-feedback>
              </b-form>
            </div>
          </div>
          <footer slot='footer'
                  class='row around-xs'>
            <b-btn variant='3v3'
                   size='sm'
                   v-if='!generalForm'
                  @click='showGeral()'><pencil-icon title='' /></b-btn>
            <b-btn variant='red'
                   size='sm'
                   v-if='generalForm'
                  @click='generalForm = false'><close-icon title='' /></b-btn>
            <b-btn variant='3v3'
                   size='sm'
                   v-if='generalForm'
                  @click='submitGeralConfig()'><save-icon title='' /></b-btn>
          </footer>
        </b-card>
        <b-card align="center">
          <div slot='header'>
            <h4>{{!clockForm ? 'Relógio do Sistema' : 'Editar relógio'}}</h4>
          </div>
          <div class='card-text start-xs'>
            <div v-if='!clockForm'>
              <p><strong>HORÁRIO:</strong> {{systemDate.DATETIME}}</p>
            </div>
            <b-form novalidate v-else @keyup.enter='submitDateTime'>
              <b-form-text id='dateInputLiveHelp'>
                Data atual *
              </b-form-text>
              <b-form-input v-model='editDateTime.date'
                            aria-describedby='dateInputLiveHelp dateInputLiveFeedback'
                            type='date'
                            :state='dateState'>
              </b-form-input>
              <b-form-invalid-feedback v-if='!dateState' id='dateInputLiveFeedback'>
                Campo inválido.
              </b-form-invalid-feedback>
              <b-form-text id='timeInputLiveHelp'>
                Horário atual *
              </b-form-text>
              <b-form-input v-model='editDateTime.time'
                            aria-describedby='timeInputLiveHelp timeInputLiveFeedback'
                            type='time'
                            :state='timeState'>
              </b-form-input>
              <b-form-invalid-feedback v-if='!timeState' id='timeInputLiveFeedback'>
                Campo inválido.
              </b-form-invalid-feedback>
            </b-form>
          </div>
          <footer slot='footer'
                  class='row around-xs'>
            <b-btn variant='3v3'
                  size='sm'
                  v-if='!clockForm'
                  @click='showClock()'><pencil-icon title='' /></b-btn>
            <b-btn variant='red'
                  size='sm'
                  v-if='clockForm'
                  @click='clockForm = false'><close-icon title='' /></b-btn>
            <b-btn variant='3v3'
                  size='sm'
                  v-if='clockForm'
                  @click='submitDateTime()'><save-icon title='' /></b-btn>
          </footer>
        </b-card>
      </b-card-group>
      <b-card-group deck :class="computedClass">
        <b-card>
          <div slot="header">
            <h4>Horário de ponta</h4>
          </div>
          <div class="card-text start-xs">
            <p class="text-muted small">
              Janela usada pelo toggle "Pausar no horário de ponta" nas
              agendas do PIR. Feriados nacionais cadastrados no card ao lado
              isentam o dia inteiro, independente dos dias marcados abaixo.
            </p>
            <b-form-text>Início</b-form-text>
            <b-form-input v-model="peakHourForm.START_TIME" type="time" size="sm" />
            <b-form-text class="mt-2">Fim</b-form-text>
            <b-form-input v-model="peakHourForm.END_TIME" type="time" size="sm" />
            <b-form-text class="mt-2">Dias em que se aplica</b-form-text>
            <center>
              <b-button-group>
                <b-btn v-for="(d, index) in peakHourDays" :key="index" @click="togglePeakHourDay(index)"
                  :variant="isPeakHourDayActive(index) ? '3v3' : 'danger'" size="sm">
                  {{ d.text }}
                </b-btn>
              </b-button-group>
            </center>
          </div>
          <footer slot="footer" class="row around-xs">
            <b-btn size="sm" variant="3v3" @click="savePeakHourConfig">Salvar</b-btn>
          </footer>
        </b-card>
        <b-card>
          <div slot="header">
            <h4>Feriados (horário de ponta)</h4>
          </div>
          <div class="card-text start-xs">
            <p class="text-muted small">
              O horário de ponta não se aplica em feriados nacionais -- o dia
              inteiro segue tarifa fora de ponta.
            </p>
            <b-table
              hover
              striped
              small
              responsive
              :items="holidays"
              :fields="holidayFields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAllHoliday"
                  v-model="allHolidaySelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selHoliday"
                ></b-form-checkbox>
              </template>
              <template slot="LABEL" slot-scope="row">
                {{ holidayDateLabel(row.item) }}
              </template>
            </b-table>
          </div>
          <footer slot="footer" class="row around-xs">
            <b-btn
              size="sm"
              variant="3v3"
              v-if="selHoliday.length == 1"
              @click="editHoliday"
              ><pencil-icon title=""
            /></b-btn>
            <b-btn size="sm" variant="3v3" @click="addHoliday"
              ><plus-icon title=""
            /></b-btn>
            <b-btn
              size="sm"
              variant="3v3"
              v-if="selHoliday.length"
              @click="delHoliday"
              ><delete-icon title=""
            /></b-btn>
          </footer>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import { settings, peakHourConfig, peakHourHolidays } from '@/api'

const PEAK_HOUR_DAYS = [
  { text: "D", value: 1 },
  { text: "S", value: 2 },
  { text: "T", value: 4 },
  { text: "Q", value: 8 },
  { text: "Q", value: 16 },
  { text: "S", value: 32 },
  { text: "S", value: 64 },
];

function pad2(n) {
  return String(n).padStart(2, "0");
}

export default {
  name: 'settings',
  props:{
    mobile: Boolean
  },
  created() {
    settings.generalSettings().then(ret => {
      this.generalSettings = ret;
      return settings.systemDate();
    }).then(ret => {
      this.systemDate = ret;
    }).catch(err => console.log(err));
    this.loadPeakHourConfig();
    this.attHolidayList();
  },
  data () {
    return {
      generalForm: false,
      clockForm: false,
      editDateTime: {
        date: '',
        time: ''
      },
      editGeneralSett: {
        SHUTDOWN_TIMER: null,
        MANUAL_TIMER: null,
        PING_PACKAGES: null
      },
      generalSettings: {
        ID: null,
        UPDATE: '2000-00-00T00:00:00.000Z',
        SHUTDOWN_TIMER: null,
        MANUAL_TIMER: null,
        PING_PACKAGES: null
      },
      systemDate: {
        DATETIME:'Sun  1 Jan 00:00:0 -00 2000\n'
      },
      holidayFields: [
        { key: "CHECK", label: "" },
        { key: "NAME", label: "Nome" },
        { key: "LABEL", label: "Data" },
      ],
      holidays: [],
      allHolidaySelected: false,
      selHoliday: [],
      holidaySelected: {},
      holidayForm: {
        NAME: null,
        RECURRING: true,
        DATE: "",
      },
      holidayTitleDialog: "",
      peakHourDays: PEAK_HOUR_DAYS,
      peakHourForm: {
        START_TIME: "",
        END_TIME: "",
        ACTIVE_DAYS: 127,
      },
    }
  },
  watch: {
    selHoliday() {
      this.allHolidaySelected =
        this.selHoliday.length == this.holidays.length;
    },
  },
  computed: {
    computedClass(){
      if(this.mobile){
        return "mobile-header pt-5"
      }
      return "desktop-header mt-4"
    },
    computedClassHeader(){
      if(this.mobile){
        return "page-title config-title-mobile col-xs-12  mt-0"
      }
      return "page-title config-title col-xs-12  mt-0"
      
    },
    batState () {
      return this.editGeneralSett.SHUTDOWN_TIMER !== '';
    },
    manualState () {
      return this.editGeneralSett.MANUAL_TIMER !== '';
    },
    packState () {
      return this.editGeneralSett.PING_PACKAGES !== '';
    },
    dateState () {
      return this.editDateTime.date !== '';
    },
    timeState () {
      return this.editDateTime.time !== '';
    },
    holidayNameState() {
      return this.holidayForm.NAME != "" && this.holidayForm.NAME != null;
    },
    holidayDateState() {
      return this.holidayForm.DATE != "" && this.holidayForm.DATE != null;
    },
    holidayDayMonthPreview() {
      if (!this.holidayDateState) return "";
      const [, month, day] = this.holidayForm.DATE.split("-");
      return `${day}/${month}`;
    },
  },
  methods: {
    resetForm(type) {
      if (type == 'general') {
        this.editGeneralSett.SHUTDOWN_TIMER = this.generalSettings.SHUTDOWN_TIMER ? this.generalSettings.SHUTDOWN_TIMER : null;
        this.editGeneralSett.MANUAL_TIMER = this.generalSettings.MANUAL_TIMER ? this.generalSettings.MANUAL_TIMER : null;
        this.editGeneralSett.PING_PACKAGES = this.generalSettings.PING_PACKAGES ? this.generalSettings.PING_PACKAGES : null;
      }
      if (type == 'clock') {
        this.editDateTime.date = '';
        this.editDateTime.time = '';
      }
    },
    showGeral() {
      this.resetForm('general');
      this.generalForm = true;
    },
    submitGeralConfig(evt) {
      if (this.batState &&
          this.manualState &&
          this.packState) {
        let data = {
          ID: this.generalSettings.ID,
          SHUTDOWN_TIMER: this.editGeneralSett.SHUTDOWN_TIMER,
          MANUAL_TIMER: this.editGeneralSett.MANUAL_TIMER,
          PING_PACKAGES: this.editGeneralSett.PING_PACKAGES
        }
        this.generalForm = false;
        settings.updateConfigGeneral(data).then(ret => {
          alert(ret.log,ret.alert);
          if (ret.status)
            settings.generalSettings().then(genSet => this.generalSettings = genSet);
        }).catch(err => {
          console.log(err);
          alert('Ocorreu um erro.');
        });
      }
    },
    showClock() {
      this.resetForm('clock');
      this.clockForm = true;
    },
    dateFormat(date) {
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      date = date.split('-');
      return date[2]+' '+months[parseInt(date[1]-1)].toUpperCase()+' '+date[0];
    },
    submitDateTime(evt) {
      if (this.timeState &&
          this.dateState) {
        let data = { 'DATETIME': this.dateFormat(this.editDateTime.date) + ' ' + this.editDateTime.time };
        this.clockForm = false;
        settings.updateDatetimeSettings(data).then(ret => {
          alert(ret.log,ret.alert);
          if (ret.status)
            settings.systemDate().then(systemDate => this.systemDate = systemDate);
        }).catch(err => {
          alert('Ocorreu um erro.')
        });
        // this.resetForm('clock'); //se a resposta da requisição for ok, reseta o formulário e fecha
      }
    },
    loadPeakHourConfig() {
      peakHourConfig
        .get()
        .then((ret) => {
          this.peakHourForm = {
            START_TIME: (ret.START_TIME || "").slice(0, 5),
            END_TIME: (ret.END_TIME || "").slice(0, 5),
            ACTIVE_DAYS: ret.ACTIVE_DAYS != null ? ret.ACTIVE_DAYS : 127,
          };
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao carregar o horário de ponta.");
        });
    },
    savePeakHourConfig() {
      peakHourConfig
        .edit(this.peakHourForm)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.loadPeakHourConfig();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao salvar o horário de ponta.");
        });
    },
    isPeakHourDayActive(index) {
      return !!(this.peakHourForm.ACTIVE_DAYS & this.peakHourDays[index].value);
    },
    togglePeakHourDay(index) {
      const bit = this.peakHourDays[index].value;
      this.peakHourForm.ACTIVE_DAYS = this.isPeakHourDayActive(index)
        ? this.peakHourForm.ACTIVE_DAYS - bit
        : this.peakHourForm.ACTIVE_DAYS + bit;
    },
    holidayDateLabel(item) {
      if (item.RECURRING) {
        return `${pad2(item.DAY)}/${pad2(item.MONTH)} (todo ano)`;
      }
      if (!item.DATE) return "";
      const [year, month, day] = item.DATE.slice(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    toggleAllHoliday() {
      this.allHolidaySelected = !this.allHolidaySelected;
      if (this.selHoliday.length < this.holidays.length) {
        this.selHoliday = this.holidays.slice();
      } else if (this.selHoliday.length == this.holidays.length) {
        this.selHoliday = [];
      }
    },
    addHoliday() {
      this.resetHolidayPage();
      this.holidayTitleDialog = "Adicionar feriado";
      this.$refs.formHoliday.show();
    },
    editHoliday() {
      this.holidaySelected = this.selHoliday[0];
      this.holidayTitleDialog = `Editar feriado ${this.holidaySelected.NAME}`;
      const s = this.holidaySelected;
      this.holidayForm = {
        NAME: s.NAME,
        RECURRING: !!s.RECURRING,
        DATE: s.RECURRING
          ? `2000-${pad2(s.MONTH)}-${pad2(s.DAY)}`
          : (s.DATE || "").slice(0, 10),
      };
      this.$refs.formHoliday.show();
    },
    delHoliday() {
      this.holidaySelected = { items: this.selHoliday };
      this.holidayTitleDialog =
        this.selHoliday.length +
        (this.selHoliday.length == 1
          ? " feriado será excluído."
          : " feriados serão excluídos.");
      this.$refs.deleteHoliday.show();
    },
    confirmDeleteHoliday() {
      peakHourHolidays
        .del(this.holidaySelected.items)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attHolidayList();
        })
        .catch((err) => console.log(err));
    },
    submitHoliday() {
      const [, month, day] = this.holidayForm.DATE.split("-");
      let data = {
        ID: this.holidaySelected.ID ? this.holidaySelected.ID : null,
        NAME: this.holidayForm.NAME,
        RECURRING: this.holidayForm.RECURRING,
        MONTH: Number(month),
        DAY: Number(day),
        DATE: this.holidayForm.DATE,
      };
      let request = data.ID
        ? peakHourHolidays.edit(data)
        : peakHourHolidays.add(data);

      request
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attHolidayList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formHoliday.hide();
    },
    attHolidayList() {
      peakHourHolidays
        .list()
        .then((holidays) => {
          this.holidays = holidays;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar lista de feriados. Recarregue a página."
          );
          console.log(err);
        });
      this.resetHolidayPage();
    },
    resetHolidayPage() {
      this.holidayForm = {
        NAME: null,
        RECURRING: true,
        DATE: "",
      };
      this.allHolidaySelected = false;
      this.selHoliday = [];
      this.holidaySelected = {};
      this.holidayTitleDialog = "";
    },
  }
}
</script>

<style scoped>
.card-text>div>p{
  color:var(--text-gray-primary);
}
.config-title-mobile{
  top: 36px;

}

.config-title{
  max-height: 1.1em;
  padding: 0 0 4px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@media screen and (max-width:767px){
  .card-text{
    font-size: 0.88em;
  }
}
</style>
